import axios from 'axios'
import { Loading, Message } from 'element-ui'

// 创建 axios 实例
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  timeout: 15000
})

// 请求拦截器
service.interceptors.request.use(
  config => {
    // const token = localStorage.getItem('token')
    // if (token) {
    //   config.headers.Authorization = token
    // }
    return config
  },
  error => Promise.reject(error)
)

// 响应拦截器
service.interceptors.response.use(
  response => response.data,
  error => {
    Message.error(error.message || '请求失败')
    return Promise.reject(error)
  }
)

// 全局 Loading 实例
let loadingInstance = null
let loadingCount = 0

// 显示 Loading
const showLoading = () => {
  if (loadingCount === 0) {
    loadingInstance = Loading.service({
      fullscreen: true,
      text: '加载中...',
        // background: 'rgba(0, 0, 0, 0.7)'
    })
  }
  loadingCount++
}

// 隐藏 Loading
const hideLoading = () => {
  loadingCount--
  if (loadingCount === 0 && loadingInstance) {
    loadingInstance.close()
    loadingInstance = null
  }
}

// 统一处理响应数据
const handleResponse = (res, resolve, reject, showError) => {
  if (res.code === 1) {
    resolve(res)
  } else if (res.code === 0) {
    if (showError) {
      Message({
        message: res.message || '操作失败',
        type: 'error',
        duration: 3000
      })
    }
    reject(res)
  } else {
    resolve(res)
  }
}

// 封装 GET 请求
export const get = (url, params = {}, options = { showLoading: true, showError: true }) => {
  if (options.showLoading) showLoading()

  return new Promise((resolve, reject) => {
    service.get(url, { params })
      .then(res => {
        if (options.showLoading) hideLoading()
        handleResponse(res, resolve, reject, options.showError)
      })
      .catch(err => {
        if (options.showLoading) hideLoading()
        reject(err)
      })
  })
}

// 封装 POST 请求
export const post = (url, data = {}, options = { showLoading: true, showError: true }) => {
  if (options.showLoading) showLoading()

  return new Promise((resolve, reject) => {
    service.post(url, data)
      .then(res => {
        if (options.showLoading) hideLoading()
        handleResponse(res, resolve, reject, options.showError)
      })
      .catch(err => {
        if (options.showLoading) hideLoading()
        reject(err)
      })
  })
}

export default service